import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { UIRouterModule } from '@uirouter/angular';
import { FormFieldModule } from '../../form/form-field/form-field.module';
import { InputModule } from '../../form/input/input.module';
import { CardModule } from '../../layout/card/card.module';
import { LoadingModule } from '../../layout/loading/loading.module';
import { ButtonModule } from '../../ui/button/button.module';
import { LinkModule } from '../../ui/link/link.module';
import { ForgotPasswordCardComponent } from './forgot-password-card.component';

@NgModule({
  declarations: [ForgotPasswordCardComponent],
  imports: [
    CommonModule,
    UIRouterModule,
    CardModule,
    LoadingModule,
    InputModule,
    ButtonModule,
    LinkModule,
    ReactiveFormsModule,
    FormFieldModule,
  ],
  exports: [ForgotPasswordCardComponent],
})
export class ForgotPasswordCardModule {}
